import { css } from "lit";
import Fontawesome from "lit-fontawesome";
import { Style } from "../Styles";
import { LeafletMarkerClusterStyle } from "./LeafletMarkerClusterStyle";

export const styles = [
    Style,
    Fontawesome,
    LeafletMarkerClusterStyle,
    css`
        :host {
            display: block;
        }

        .container {
            width: 100%;
            height: 100%;
            position: relative;
        }

        .map {
            width: 100%;
            height: 100%;

            // Create a new z-index stacking context so the UI renders over the map
            isolation: isolate;
        }

        .map-buttons {
            position: absolute;
            bottom: 5em;
            right: 0.5em;
        }

        .map-buttons sl-icon-button {
            font-size: min(3vh, 2.5em);
            background-color: white;
            border-radius: 50%;
            border: var(--ds-border);
            padding: 0.4em;
            color: black;
        }

        .div-icon-marker {
            width: auto !important;
            height: auto !important;
        }

        .top-center-controls {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 1rem;
            min-width: 8rem;
        }

        .bottom-left-controls {
            position: absolute;
            left: 1rem;
            bottom: 5rem;
            min-width: 8rem;
        }

        .statistic {
            display: flex;
            justify-content: center;
            background-color: white;
            color: black;
            border-radius: 2em;
            width: auto;
            padding: 0.5em;
        }

        .current-location {
            position: absolute;
            bottom: 0.2em;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
        }

        .current-location span {
            background-color: var(--surface-bg-color);
            border-radius: 2em;
            width: auto;
            padding: 0.5em;
            border-color: var(--ds-surface-bg-color);
        }

        .home-icon-marker {
            width: 2em;
            height: 2em;
            background-color: white;
            color: black;
            border-radius: 50%;
            transform: translate(-50%, -50%);
            padding: 0.5em;
        }

        /* Markers */

        .geojson-marker-text {
            background-color: white;
            color: black;
            border-radius: 0.2em;
            padding: 0.3em;
            white-space: nowrap;
        }

        /* Measure tool */

        .leaflet-control-measure {
            font-size: 2em;
            font-weight: bold;
            /* background-color: var(--surface-bg-color) !important; */
            width: auto !important;
            height: auto !important;
            padding: 0.3em;
        }

        .leaflet-control-measure sl-icon {
            color: gray;
        }

        .leaflet-control-measure-on sl-icon {
            color: black;
        }

        .leaflet-bar-part-top-and-bottom {
            -webkit-border-radius: 4px 4px 4px 4px;
            border-radius: 4px 4px 4px 4px;
            border-bottom: none;
        }

        .leaflet-touch .leaflet-bar-part-top-and-bottom {
            -webkit-border-radius: 7px 7px 7px 7px;
            border-radius: 7px 7px 7px 7px;
            border-bottom: none;
        }

        .leaflet-control-measure-on .leaflet-control-measure {
            box-shadow: 0 0 8px rgba(10, 10, 10, 1);
        }

        .leaflet-measure-tooltip {
            font:
                12px "Helvetica Neue",
                Arial,
                Helvetica,
                sans-serif;
            background-color: rgba(255, 255, 255, 0.7);
            box-shadow: 0 0 5px #bbb;
            margin: 0;
            padding: 2px;
            width: auto !important;
            height: auto !important;
            white-space: nowrap;
        }

        .leaflet-measure-tooltip-total {
            font-weight: bold;
            color: black;
        }

        .leaflet-measure-tooltip-difference {
            color: #444;
        }

        .current-location-icon i {
            color: limegreen;
            -webkit-text-stroke-width: 2px;
            -webkit-text-stroke-color: white;
        }

        sl-icon-button::part(base):hover,
        sl-icon-button::part(base):focus-visible {
            color: black;
        }

        .tracking::part(base),
        .tracking::part(base):hover,
        .tracking::part(base):focus-visible {
            color: black;
        }

        .not-tracking::part(base),
        .not-tracking::part(base):hover,
        .not-tracking::part(base):focus-visible {
            color: grey;
        }

        sl-select::part(combobox) {
            border: var(--ds-border);
        }
    `,
];
